import React, { Fragment } from "react";

const ItemsList = (props) => {
  return <Fragment>
    <div className="col">
      <button className="btn m-2 border" style={{minWidth: "150px", color: props.disable ? "gray": "green"}} disabled={props.disable} 
        onClick={() => props.addItemToVehicleInspectionItem({name: props.name})}>
        {props.name}
      </button>
    </div>
  </Fragment>
}

export default ItemsList;
